import * as ModalConfirm from './components/ModalConfirm.css';

export default {
	ModalConfirm
};
